/**
 * "Take the tour", in a workflow's header beside its other actions: replays
 * that page's tour. The same outlined teal button the KPI dashboard's toolbar
 * has, so it reads as the same control on every workflow.
 */

import { CircleHelp } from "lucide-react";
import React from "react";

const TakeTourButton: React.FC<{ onClick: () => void }> = ({ onClick }) => (
	<button
		type="button"
		onClick={onClick}
		className="inline-flex h-9 items-center gap-1.5 whitespace-nowrap rounded-lg border border-[#99CFCD] bg-white px-3.5 text-sm font-medium text-[#004C4B] hover:bg-[#f6fbfb] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#008782]"
	>
		<CircleHelp className="h-4 w-4" aria-hidden="true" />
		Take the tour
	</button>
);

export default TakeTourButton;
